import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import { themes, scrollTop, tableRowSize, iconStyle } from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { Loader } from "components/Loader";
import { templateGroupViewHeader } from "pages/HR/Headers";
import { IndividualUserComponentHeader } from "pages/HR/Headers";
import comLogo from "../../../../../../assets/img/brand/company_logo.png";
import { customGetAPI } from "services/utils/CustomAPI";
import { CompanyProgress } from "components/CustomComponents/CustomSlider";
import { tooltipStyleProps } from "services/constants/Styles";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { templateEmployeeViewHeader } from "pages/HR/Headers";
import { setFilterApi } from "services/Redux/userManagament";
import {
  Typography,
  Box,
  Paper,
  IconButton,
  Drawer,
  Tooltip,
} from "@mui/material";
import { Add, Groups, Person, ArrowRight } from "@mui/icons-material";
import { stickyHeader } from "services/constants";
import { drawerStyle } from "services/constants";
import { SalaryComponentEmployeeView } from "../EmployeeView";
import { ViewUserTemplateScreen } from "../ViewUserTemplateScreen";
import { checkEditorPermission } from "services/utils/HelperFunction";

export const SalaryTemplateGroupView = ({ setSalaryConfigItem }) => {
  const { domain, userScreenAccess, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );

  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [componentDetails, setComponentDetails] = useState([]);
  const [userData, setUserData] = useState({});
  const [expendRowId, setExpendRowId] = useState(null);
  const [individualLoader, setIndividualLoader] = useState(false);
  const [expandDetails, setExapandDetils] = useState([]);
  const [expandItem, setExpandItem] = useState([]);
  const [triggerApi, setTriggerApi] = useState(false);
  const [showUserView, setShowUserView] = useState(false);
  const containerRef = useRef(null);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);
  const [userComponentDetails, setUserComponentDetails] = useState([]);
  const [userComponentData, setUserComponentData] = useState([]);
  const [trigger, setTrigger] = useState(false);

  let group_check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Salary Configuration",
    "Group Salary Template"
  );

  let employee_check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Salary Configuration",
    "Employee Salary Template"
  );

  const {
    result: templateData,
    loading,
    setLoad: reCallApi,
  } = useFetch(
    `${domain}hrzone/salary/salary_template/get-all-template/?company_id=${topbarCompanyId}`
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleViewComponent = () => {
    setIsViewPanelOpen(true);
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      setIndividualLoader(true);
      const res = await customGetAPI(
        `${domain}hrzone/salary/salary_template/get-all-template-employee-details/?template_id=${expandItem?.id}`
      );
      if (res.ok) {
        setExapandDetils(res?.responseDetails);
        setTriggerApi(false);
        setIndividualLoader(false);
      } else {
        setTriggerApi(false);
        setIndividualLoader(false);
      }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
    }
  }, [domain, expandItem?.id, triggerApi]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      showUserView
        ? setUserComponentDetails(filteredData)
        : setComponentDetails(filteredData);
      if (page * rowsPerPage >= filteredData?.length) setPage(0);
    },
    [page, rowsPerPage, showUserView]
  );

  const handleToggle = (index, value) => {
    setExpendRowId((prev) => (prev === index ? null : index));
    setExapandDetils([]);
    setExpandItem(value);
    setTriggerApi(true);
  };

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
    }
  }, [reCallApi, topbarCompanyId]);

  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Salary Template
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Assign or move employees to this template
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <IconButton
              sx={iconStyle}
              onClick={() => {
                setShowUserView(!showUserView);
                setSalaryConfigItem(
                  !showUserView
                    ? "Employee Salary Template"
                    : "Group Salary Template"
                );
                dispatch(setFilterApi(true));
                setExpendRowId(null);
              }}
            >
              {showUserView ? (
                <Groups sx={{ color: themes.primaryIndicator }} />
              ) : (
                <Person sx={{ color: themes.primaryIndicator }} />
              )}
            </IconButton>
            <Tooltip
              title="New Salary Template"
              arrow
              slotProps={tooltipStyleProps}
            >
              <IconButton
                sx={iconStyle}
                onClick={() => {
                  setSalaryConfigItem("Salary Template");
                }}
              >
                <Add sx={{ color: themes.primaryIndicator }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Paper sx={{ width: "100%", height: "78vh" }}>
          <CustomFilter
            title={"Salary Template Records"}
            filterHeaders={
              showUserView
                ? templateEmployeeViewHeader
                : templateGroupViewHeader
            }
            data={showUserView ? userComponentData : templateData}
            filteredData={
              showUserView ? userComponentDetails : componentDetails
            }
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={
              showUserView ? employee_check_access : group_check_access
            }
          />

          {showUserView ? (
            <SalaryComponentEmployeeView
              setIsViewPanelOpen={setIsViewPanelOpen}
              setUserData={setUserData}
              userComponentDetails={userComponentDetails}
              setUserComponentDetails={setUserComponentDetails}
              setUserComponentData={setUserComponentData}
              trigger={trigger}
              setTrigger={setTrigger}
              page={page}
              setPage={setPage}
            />
          ) : (
            <Mui.Grid sx={{ ml: 2, mr: 2 }}>
              <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
                <Mui.Table className="border">
                  <Mui.TableHead sx={stickyHeader}>
                    <Mui.TableRow sx={tableRowSize}>
                      {templateGroupViewHeader?.map((value) => (
                        <Mui.TableCell
                          sx={{
                            color: themes.headLine,
                            fontWeight: "bold",
                          }}
                        >
                          {value?.name}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>
                  <Mui.TableBody>
                    {componentDetails?.length === 0 ? (
                      <InfoMessage dataLength={templateData} />
                    ) : (
                      componentDetails
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        ?.map((value, index) => (
                          <>
                            <Mui.TableRow key={value.id} sx={tableRowSize}>
                              {templateGroupViewHeader.map((head) =>
                                head?.key === "Action" ? (
                                  <Mui.TableCell
                                    key={`${value.id}-action`}
                                    sx={{ width: 70 }}
                                  >
                                    <ArrowRight
                                      sx={{
                                        transition: "0.3s",
                                        transform:
                                          expendRowId === value.id
                                            ? "rotate(90deg)"
                                            : "rotate(0deg)",
                                        cursor: "pointer",
                                        color:
                                          expendRowId === value.id
                                            ? themes?.stepActiveColor
                                            : "inherit",
                                      }}
                                      onClick={() =>
                                        handleToggle(value.id, value)
                                      }
                                    />
                                  </Mui.TableCell>
                                ) : (
                                  <Mui.TableCell
                                    key={`${value.id}-${head.key}`}
                                  >
                                    {value[head.key] ? value[head.key] : "0"}
                                  </Mui.TableCell>
                                )
                              )}
                            </Mui.TableRow>
                            {expendRowId === value.id && (
                              <Mui.TableRow>
                                <Mui.TableCell colSpan={12}>
                                  <Mui.TableContainer
                                    sx={{
                                      marginTop: 0,
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                      width: "100%px",
                                    }}
                                    className="w-96 border rounded"
                                  >
                                    <Mui.Table>
                                      <Mui.TableHead
                                        sx={{
                                          backgroundColor: themes.primary,
                                        }}
                                      >
                                        <Mui.TableRow sx={tableRowSize}>
                                          {IndividualUserComponentHeader.map(
                                            (head) => (
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.headLine,
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {head.name}
                                              </Mui.TableCell>
                                            )
                                          )}
                                        </Mui.TableRow>
                                      </Mui.TableHead>
                                      <Mui.TableBody>
                                        {individualLoader ? (
                                          <Mui.TableRow sx={tableRowSize}>
                                            <Mui.TableCell
                                              colSpan={10}
                                              style={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <CompanyProgress
                                                comLogo={comLogo}
                                                themes={themes}
                                              />
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ) : expandDetails?.length === 0 &&
                                          !individualLoader ? (
                                          <Mui.TableRow
                                            maxWidth="xl"
                                            align="left"
                                            sx={tableRowSize}
                                          >
                                            <Mui.TableCell colSpan={12}>
                                              <Mui.Alert
                                                sx={{ marginTop: 3 }}
                                                severity="info"
                                              >
                                                No data available
                                              </Mui.Alert>
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ) : (
                                          expandDetails?.map((detail) => (
                                            <Mui.TableRow sx={tableRowSize}>
                                              {IndividualUserComponentHeader?.map(
                                                (head) => (
                                                  <Mui.TableCell
                                                    key={head.key}
                                                    onClick={() => {
                                                      handleViewComponent();
                                                      setUserData(detail);
                                                    }}
                                                    sx={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {detail[head.key] ||
                                                    detail[head.key] === 0
                                                      ? detail[head.key]
                                                      : "N/A"}
                                                  </Mui.TableCell>
                                                )
                                              )}
                                            </Mui.TableRow>
                                          ))
                                        )}
                                      </Mui.TableBody>
                                    </Mui.Table>
                                  </Mui.TableContainer>
                                </Mui.TableCell>
                              </Mui.TableRow>
                            )}
                          </>
                        ))
                    )}
                  </Mui.TableBody>
                </Mui.Table>
              </Mui.TableContainer>
              <Box sx={{ mt: 1 }}>
                {componentDetails?.CustomFilterlength > 25 && (
                  <Mui.TablePagination
                    className="custom-pagination"
                    component="div"
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    count={componentDetails?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            </Mui.Grid>
          )}
        </Paper>
      </Box>

      <Drawer
        anchor="right"
        open={isViewPanelOpen}
        onClose={() => {
          handleViewClosePanel();
        }}
        sx={drawerStyle}
      >
        <ViewUserTemplateScreen
          onClose={handleViewClosePanel}
          userData={userData}
        />
      </Drawer>
    </React.Fragment>
  );
};
